"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amb = _interopRequireDefault(require("./amb.Logger"));

var _amb2 = require("./amb.Constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var MessagesRedeliveryManager = function MessagesRedeliveryManager() {
  var LOGGER = new _amb.default('amb.MessagesRedeliveryManager');
  var REDELIVERY_MESSAGE = 'redelivery_message';
  var REDELIVERY_NOTIFICATION = 'redelivery_notification';
  var IS_LAST_REDELIVERY = "is_last_redelivery";
  var CAN_REDELIVER = "can_redeliver";
  var REDELIVERY_NOT_AUTHORIZED = "redelivery_not_authorized";
  var redeliveredMessages = [];
  var originalMessages = [];
  var awaitingRedeliveredMessages;
  var isPendingDelivery;

  var isLastRedelivered = function isLastRedelivered(message) {
    return isRedelivered(message) && message.ext[REDELIVERY_MESSAGE][IS_LAST_REDELIVERY] === true;
  };

  var noneToRedeliverTag = function noneToRedeliverTag(message) {
    return message.ext[REDELIVERY_NOTIFICATION] && message.ext[REDELIVERY_NOTIFICATION][CAN_REDELIVER] === false;
  };

  var isRedelivered = function isRedelivered(message) {
    return message.ext[REDELIVERY_MESSAGE];
  };

  var redeliveryAuthorized = function redeliveryAuthorized(message) {
    return message.ext[REDELIVERY_MESSAGE][REDELIVERY_NOT_AUTHORIZED] !== true;
  };

  var areSameMessages = function areSameMessages(m1, m2) {
    return m1.ext[_amb2.MSG_SHARD] === m2.ext[_amb2.MSG_SHARD] && m1.ext[_amb2.MSG_NUM] === m2.ext[_amb2.MSG_NUM];
  };

  var isAlreadyReceived = function isAlreadyReceived(arr, message) {
    return arr.find(function (messageExisting) {
      return areSameMessages(messageExisting, message);
    });
  };

  var getDeDupedMessages = function getDeDupedMessages(baseArr, dupeArr) {
    return dupeArr.filter(function (message) {
      return !isAlreadyReceived(baseArr, message);
    });
  };

  var areMessagesAvailable = function areMessagesAvailable() {
    return redeliveredMessages.length > 0 || originalMessages.length > 0;
  };

  var stringifyMetaInfo = function stringifyMetaInfo(message) {
    return _amb2.MSG_NUM + ':' + message.ext[_amb2.MSG_NUM] + ',' + _amb2.MSG_SHARD + ':' + message.ext[_amb2.MSG_SHARD];
  };

  function stringifyMetaArr(arr) {
    var logMessage = '';

    var _iterator = _createForOfIteratorHelper(arr),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var message = _step.value;
        logMessage = logMessage.concat('<' + stringifyMetaInfo(message) + '>');
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return logMessage;
  }

  function clearMessages() {
    LOGGER.debug('Clearing all messages');
    redeliveredMessages = [];
    originalMessages = [];
  }

  function redeliveryOver() {
    LOGGER.debug('Redelivery over');
    awaitingRedeliveredMessages = false;
    isPendingDelivery = true;
  }

  return {
    resetState: function resetState() {
      clearMessages();
      awaitingRedeliveredMessages = true;
      isPendingDelivery = false;
    },
    containsMetaInfo: function containsMetaInfo(message) {
      return message.ext && message.ext[_amb2.MSG_NUM] && message.ext[_amb2.MSG_SHARD];
    },
    shouldDeliver: function shouldDeliver(message) {
      // Enqueue every message until all redelivered messages are received
      if (awaitingRedeliveredMessages) {
        if (noneToRedeliverTag(message)) {
          LOGGER.debug('No messages to redeliver');
          awaitingRedeliveredMessages = false;
          return false;
        }

        if (!this.containsMetaInfo(message)) return false;

        if (isRedelivered(message) && redeliveryAuthorized(message)) {
          LOGGER.debug('Processing redelivered - ' + stringifyMetaInfo(message));
          redeliveredMessages.push(message);
        } else if (isRedelivered(message) && !redeliveryAuthorized(message)) {
          LOGGER.debug('Not Processing unauthorized redelivery message - ' + stringifyMetaInfo(message));
        } else {
          originalMessages.push(message);
          LOGGER.debug('Processing original - ' + stringifyMetaInfo(message));
        }

        if (isLastRedelivered(message)) redeliveryOver();
        return false;
      } // Worker thread message: new


      if (!isAlreadyReceived(redeliveredMessages, message)) {
        LOGGER.debug('Out of redelivery. New message received: ' + stringifyMetaInfo(message));
        clearMessages();
        return true;
      } // Worker thread message: duplicate


      LOGGER.debug('Dropping duplicate: ' + stringifyMetaInfo(message));
      return false;
    },
    shouldDeliverPendingMessages: function shouldDeliverPendingMessages() {
      return isPendingDelivery;
    },
    getAllPendingMessages: function getAllPendingMessages() {
      var pendingMessages = [];

      if (areMessagesAvailable()) {
        var deDupedOriginal = getDeDupedMessages(redeliveredMessages, originalMessages);
        pendingMessages = redeliveredMessages.concat(deDupedOriginal);
      }

      LOGGER.debug('Flushing: ' + stringifyMetaArr(pendingMessages));
      redeliveredMessages = pendingMessages; //retain list for later comparison

      originalMessages = []; // clear delivered messages

      isPendingDelivery = false;
      return pendingMessages;
    },
    getMissedMessagesSize: function getMissedMessagesSize() {
      return redeliveredMessages.length;
    },
    getOriginalMessagesSize: function getOriginalMessagesSize() {
      return originalMessages.length;
    }
  };
};

var _default = MessagesRedeliveryManager;
exports.default = _default;